<template>
  <div class="home">
    <div v-if="!isShowSwipe" class="footer">
      <div class="ybm_box">
        <van-nav-bar left-arrow title="已报名赛事" @click-left="onClickLeft"/>
      </div>
      <div class="zwbs">
        <img alt src="../assets/img_zwzd.png"/>
        <span>暂无报名比赛...</span>
      </div>
    </div>
    <div v-if="isShowSwipe" class="inner">
      <van-tabs ref="tabs" v-model:active="tabs" shrink @click-tab="clickTab">
        <template #nav-bottom>
          <div class="container_box" style="height: 44px"></div>
        </template>
        <van-tab title="赛事">
          <div class="inline_in">
            <div class="swipe">
              <van-swipe :autoplay="3000" class="my-swipe" indicator-color="#1989fa">
                <van-swipe-item v-for="(item,index) in swipeList" :key="index">
                  <img :src="item"/>
                </van-swipe-item>
              </van-swipe>
            </div>
            <div class="tit">
              <div class="inner">
                <div class="l">赛事</div>
                <van-dropdown-menu :overlay="false">
                  <van-dropdown-item v-model="gameType" :options="gameList" style="height: 52px"
                                     @change="dropdownMenuChange"/>
                </van-dropdown-menu>
              </div>
            </div>
            <div class="content">
              <!-- <div class="content" :style="[isShowSwipe ? 'margin-top : 8px' : 'margin-top : 16px']"> -->
              <div class="inner">
                <div
                    v-for="(item,index) in data"
                    :key="index"
                    :class="['item', active == index ? 'active' : 'noActive' ]"
                >
                  <van-card class="van_card">
                    <template #thumb>
                      <img alt src="../assets/img_saishilogo.png"/>
                    </template>
                    <template #title>
                      <div class="title" plain type="danger">{{ item.tit }}</div>
                    </template>
                    <template #desc>
                      <div class="desc" plain type="danger">{{ item.desc }}</div>
                    </template>
                    <template #tags>
                      <div class="tags_box">
                        <div class="txt" plain type="danger">{{ item.txt }}</div>
                        <div class="showbtn">
                          <van-button class="van_button" color="#F96857" round size="mini">现在报名
                          </van-button>
                          <!--                          <div v-if="item==2" class="isPlaying">正在比赛...</div>-->
                          <!--                          <div class="isEnd">{{ item.isEnd }}</div>-->
                        </div>
                      </div>
                    </template>
                    <template #footer>
                      <van-collapse v-model="activeNames" @change="collapseChange(index)">
                        <van-collapse-item :name="index">
                          <template #title>
                            <div class="l">
                              <div class="bg_box"></div>
                              <span>{{ item.collapseData.people }}人报名</span>
                            </div>
                            <div class="r">
                              <div class="bg_box"></div>
                              <span>¥{{ item.collapseData.money }}</span>
                            </div>
                          </template>
                          <template #default>
                            <div class="c1">
                              <span>冠军队伍</span>
                              <span>
                                <span style="color:#F96857">{{ item.collapseData.first }}</span> 元（税前）
                              </span>
                            </div>
                            <div class="c2">
                              <span>亚军队伍</span>
                              <span>
                                <span style="color:#F96857">{{ item.collapseData.second }}</span> 元（税前）
                              </span>
                            </div>
                            <div class="c3">
                              <span>季军队伍</span>
                              <span>
                                <span style="color:#F96857">{{ item.collapseData.three }}</span> 元（税前）
                              </span>
                            </div>
                          </template>
                        </van-collapse-item>
                      </van-collapse>
                    </template>
                  </van-card>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="约赛">
          <Competition ref="Competition"></Competition>
        </van-tab>
      </van-tabs>
    </div>
    <!--    <div v-if="isShowSwipe" class="fix_box" @click="showSwipe">-->
    <!--      <span>{{ tabs === 0 ? '已报名' : '我的战队' }}</span>-->
    <!--    </div>-->
  </div>
</template>

<script>
import Competition from "./appointCompetition/index";

export default {
  name: "home",
  components: {Competition},
  data() {
    return {
      tabs: 0,
      swipeList: [require("../static/img/img_saishi_banner_515.png")],
      activeNames: [],
      active: -1,
      // 是否显示swiper和中间的tit
      isShowSwipe: true,
      gameType: 1,
      gameList: [
        {
          text: "全部赛事",
          value: 1
        },
        {
          text: "王者荣耀",
          value: 2
        }
        // {
        //   text: "和平精英",
        //   value: 3
        // },
        // {
        //   text: "绝地求生",
        //   value: 4
        // },
        // {
        //   text: "LOL手游",
        //   value: 5
        // },
        // {
        //   text: "永劫无间",
        //   value: 6
        // },
        // {
        //   text: "英雄联盟",
        //   value: 7
        // }
      ],
      data: [
        {
          tit: "英雄联盟团体赛(线上)",
          desc: "报名时间：9.26-10.15",
          txt: "比赛时间：10.7-10.23",
          isEnd: "已结束",
          collapseData: {
            people: "258",
            money: "3000",
            first: "2000",
            second: "1500",
            three: "500"
          }
        },
        {
          tit: '炉石传说(线上)',
          desc: "报名时间：9.26-10.15",
          txt: "比赛时间：10.7-10.23",
          isEnd: "已结束",
          collapseData: {
            people: "658",
            money: "5000",
            first: "3000",
            second: "1500",
            three: "500"
          }
        },
        {
          tit: "FIFAONLINE4(线上)",
          desc: "报名时间：9.26-10.15",
          txt: "比赛时间：10.7-10.23",
          isEnd: "已结束",
          collapseData: {
            people: "95",
            money: "2000",
            first: "1000",
            second: "700",
            three: "300"
          }
        },
      ],
    };
  },
  computed: {},
  created() {
    window.setToken = this.setToken;
  },
  mounted() {
    this.getToken();
    this.$nextTick(() => {
      this.$refs["tabs"].resize();
    });
  },
  methods: {
    // 安卓获取token方法
    getToken() {
      if (window.lianba) {
        window.lianba.getToken();
      }
    },
    setToken(token) {
    },
    collapseChange(item) {
      this.active = this.active == item ? null : item;
      this.$nextTick(() => {
        this.activeNames = [this.active];
      });
    },
    showSwipe() {
      // 赛事页面为查看已报名
      if (this.tabs === 0) {
        this.isShowSwipe = false
      }
      // 约战界面为查看我的战队
      else {
        this.$router.push({name: 'myTeam'})
      }
    },
    clickTab(item) {
      const {name} = item
      // console.log(name)
      // this.$store.commit('SET_HOME_PAGE',name)
    },
    // 点击赛事分类时保存状态,以便操作
    dropdownMenuChange() {
      this.$store.commit('SET_HOME_SAISHI', this.gameType)
    },
    // 回退
    onClickLeft() {
      this.isShowSwipe = true
    }
  }
};
</script>
<style lang="scss" >
.home {
  height: 100%;
  //min-width: 375px;
  margin: 0 auto;

  .inner {
    height: 100%;

    .van-tabs {
      height: 100%;

      .van-tabs__wrap {
        height: 44px;
        width: 100%;
        background: #fff;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99;

        .van-tabs__nav {
          padding-left: 10px;
          background: #f5f5f5;

          .van-tab__text {
            font-size: 16px;
          }

          .van-tabs__line {
            width: 20px;
            height: 4px;
            border-radius: 20px;
            background-color: #f96857;
            bottom: 19px;
          }

          .van-tab--active {
            color: #f96857;
            transition: all 0.3s;

            .van-tab__text {
              font-weight: bold;
              font-size: 18px;
            }
          }
        }
      }

      .van-tabs__content {
        height: calc(100% - var(--van-tabs-line-height));

        .van-tab__panel {
          height: 100%;
          //height: calc(100% - var(--van-tabs-line-height));
        }
      }
    }

    .inline_in {
      .swipe {
        padding: 0 16px;
        padding-top: 8px;

        .my-swipe {
          min-width: 343px;
          height: 156px;
          margin: 0 auto;
          border-radius: 8px;

          img {
            width: 100%;
            height: 100%;
          }

          // .van-swipe-item:first-child {
          //   background: skyblue;
          // }
          // .van-swipe-item:last-child {
          //   background: pink;
          // }
        }
      }

      .tit {
        margin: 0 auto;
        margin-top: 10px;
        padding: var(--van-card-padding);
        height: 22px;
        line-height: 22px;

        .inner {
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .l {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .van-dropdown-menu {
            height: 22px;

            .van-dropdown-menu__bar {
              height: 22px;
              background-color: #f5f5f5;
              box-shadow: none;

              .van-dropdown-menu__title--down:after {
                margin-top: 0;
                transform: rotate(135deg) !important;
              }

              .van-dropdown-menu__title {
                display: flex;
                align-items: center;
                padding-right: 0;

                div {
                  margin-right: 8px;
                }
              }

              .van-dropdown-menu__title:after {
                content: "";
                border: 1px solid #999;
                border-left: none;
                border-bottom: none;
                transform: rotate(45deg);
                width: 6px;
                height: 6px;
                margin-top: -5px;
                transition: all 0.4s ease;
              }

              .van-dropdown-menu__title--active {
                color: #323233;
              }
            }

            .van-dropdown-item {
              width: 100px;
              // height: 180px;
              left: calc(100% - 116px);
              top: 212px;
              z-index: 2022;

              .van-popup {
                border-radius: 8px;
                position: relative;

                .van-cell {
                  height: 26px;
                  line-height: 26px;
                  font-size: 12px;
                  padding: 0;
                  // text-align: center;
                  text-indent: 14px;

                  .van-cell__value {
                    display: none;
                  }
                }

                .van-cell:after {
                  opacity: 0;
                }

                .van-dropdown-item__option--active {
                  background-color: #4a7dfe;
                  color: #fff;
                }
              }
            }
          }

          .r {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .r::after {
            content: "";
            display: inline-block;
            width: 6px;
            height: 6px;
            border: 1px solid #333;
            border-bottom: none;
            border-left: none;
            transform: rotate(45deg);
            margin-left: 4px;
          }
        }
      }

      .content {
        background: #f5f5f5;

        .inner {
          min-width: 375px;
          margin: 0 auto;

          .item {
            transition: all 0.5s ease;

            .van_card {
              .van-card__header {
                height: 87px;
                display: flex;
                align-items: center;
                padding: 0 16px;

                .van-card__thumb {
                  width: 55px;
                  height: 55px;

                  img {
                    width: 100%;
                    height: 100%;
                  }
                }

                .van-card__content {
                  display: flex;
                  justify-content: center;

                  .title {
                    color: #333333;
                    font-size: 16px;
                    font-weight: bold;
                  }

                  .desc {
                    color: #999999;
                    font-size: 12px;
                  }

                  .tags_box {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;

                    .txt {
                      color: #4a7dfe;
                      font-size: 12px;
                    }

                    .showbtn {
                      .van_button {
                        width: 80px;
                        height: 26px;
                      }
                    }

                    .isPlaying {
                      color: #4a7dfe;
                      font-size: 12px;
                      width: 60px;
                      text-align: left;
                    }

                    .isEnd {
                      color: #999999;
                      font-size: 12px;
                      width: 60px;
                      text-align: left;
                    }
                  }
                }

                .van-card__content > div {
                  // width: 100px;
                  // height: 88px;
                  display: flex;
                  flex-direction: column;
                  align-items: flex-start;
                  justify-content: space-evenly;
                }
              }

              .van-card__footer {
                height: 45px;

                .van-collapse-item {
                  .van-cell {
                    padding-left: 16px;
                    padding-right: 16px;

                    .van-cell__title {
                      display: flex;
                      align-items: center;
                      justify-content: space-between;

                      .l {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #333;

                        .bg_box {
                          width: 12px;
                          height: 12px;
                          background-image: url("../assets/icon_bmrs.png");
                          background-size: 12px 12px;
                          margin-right: 4px;
                        }
                      }

                      .r {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #333;

                        .bg_box {
                          width: 12px;
                          height: 12px;
                          background-image: url("../assets/cion_ssjj.png");
                          background-size: 12px 12px;
                          margin-right: 2px;
                        }
                      }
                    }
                  }

                  .van-collapse-item__wrapper {
                    height: 85px;
                    box-sizing: border-box;

                    .van-collapse-item__content {
                      display: flex;
                      flex-direction: column;
                      justify-content: space-evenly;
                      align-items: flex-start;
                      color: #999;
                      font-size: 12px;
                      height: 85px;
                      box-sizing: border-box;
                      padding-top: 0;
                      padding-bottom: 4px;

                      div {
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        span:last-child {
                        }
                      }
                    }
                  }

                  .van-collapse-item__title .van-cell__right-icon:before {
                    transform: rotate(0) translateZ(0);
                  }

                  //.van-collapse-item__title--expanded .van-cell__right-icon:before {
                  //  transform: rotate(90deg);
                  //}
                }
              }

              .van-card__footer,
              .van-card__header {
                min-width: 343px;
                background: #fff;
                box-sizing: border-box;
              }
            }
          }

          .item.active {
            margin-bottom: 85px;

            .van-collapse-item__title--expanded {
              .van-cell__right-icon:before {
                transform: rotate(90deg) !important;
              }
            }
          }

          .item.noActive {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  .ybm_box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;

    .van-nav-bar__title {
      font-size: 18px;
      color: #333333;
    }

    .van-nav-bar__left {
      .van-badge__wrapper::before {
        color: #333;
      }
    }
  }

  .fix_box {
    position: fixed;
    right: 8px;
    bottom: 200px;
    // top: 50%;
    width: 63px;
    height: 63px;
    background-image: url("../assets/iocn_qiehuanjuese.png");
    background-repeat: no-repeat;
    background-size: 63px 63px;

    span {
      line-height: 63px;
      text-align: center;
      color: #fff;
      font-size: 12px;
      font-weight: bold;
    }
  }

  .footer {
    height: 100%;

    .zwbs {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      span {
        font-size: 12px;
        color: #333333;
        margin-top: 24px;
      }
    }
  }

}
</style>
